import { combineReducers } from 'redux';
import { alertReducer, navigationReducer, organisationReducer } from '../duck/reducers';
import { loginReducer } from './login/duck/reducers';
import { recoverPasswordReducer } from './recover-password/duck/reducers';

const combinedReducer = () =>
  combineReducers({
    alertReducer,
    loginReducer,
    navigationReducer,
    organisationReducer,
    recoverPasswordReducer,
  });

export default combinedReducer;
